import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import User from '../assets/icons/feather/User.svg?react';

export function UserIcon(props: SvgIconProps) {
  return <SvgIcon component={User} inheritViewBox {...props} />;
}
